<!--影院预存中心配置/管理-->
<template>
  <div v-if="!showModal">
    <a-spin :spinning="loading">
      <a-form ref="form" :model="formState" name="form" @finish="onSearch">
        <a-row>
          <a-form-item class="ui-form__item" name="organizationId" label="影院组织">
            <a-select placeholder="请选择影院组织" v-model:value="formState.organizationId" style="width: 250px;"
                      @change="getFundCinemaList">
              <a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" name="cinemaId" label="所属影院">
            <a-select placeholder="请选择所属影院" v-model:value="formState.cinemaId" style="width: 350px;">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="item in cinemaList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" name="cinemaInfo" label="影院名称">
            <a-input v-model:value="formState.cinemaInfo" placeholder="影院名称"></a-input>
          </a-form-item>

          <a-form-item class="ui-form__item" name="isDisabled" label="状态">
            <a-select placeholder="请选择" v-model:value="formState.isDisabled" style="width: 250px;">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option :value="0">启用</a-select-option>
              <a-select-option :value="1">禁用</a-select-option>
            </a-select>
          </a-form-item>

        </a-row>

        <a-row>
          <a-col :span="18">
            <a-row v-if="fundMode == 1">
              <!--        <a-button style="margin-right: 10px" type="primary" v-permission="['']">项目预警值配置</a-button>-->
              <a-col :span="5" v-permission="['fundCenter_cinema_project_warning_config']">
                <a-button @click="onWarning" style="margin-right: 10px" type="primary">项目预警值配置</a-button>
              </a-col>
              <a-col :span="5" v-permission="['fundCenter_cinema_project_recharge']">
                <a-button style="margin-right: 10px" @click="onRecharge">项目预存充值</a-button>
              </a-col>
              <a-col :span="5" style="height: 30px;line-height: 30px;">项目预存余额：{{ projectAmount }}</a-col>
            </a-row>
          </a-col>
          <a-col :span="6" style="text-align: right;">
            <a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
            <a-button @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div style="margin-top: 20px;">
        <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="cinemaAllList">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'deductionMode'">
              <template v-if="record.deductionMode">{{ record.deductionMode == 1 ? '固定价' : '结算价' }}</template>
              <template v-else>-</template>
            </template>
            <template v-if="column.key === 'isWarnPlaceOrder'">
              {{ record.isWarnPlaceOrder == 1 ? '是' : '否' }}
            </template>
            <template v-if="column.key === 'isDisabled'">
              {{ record.isDisabled == 1 ? '禁用' : '启用' }}
            </template>
            <template v-if="column.key === 'action'">
              <a-dropdown :trigger="['click', 'hover']">
                <a-button @click.prevent>操作 <Icon icon="DownOutlined"></Icon>
                </a-button>
                <template #overlay>
                  <a-menu>
                    <div @click="onEdit(record)" v-permission="['fundCenter_cinema_edit']">
                      <a-menu-item>
                        编辑
                      </a-menu-item>
                    </div>
                    <div @click="onRecharge(record)" v-if="fundMode == 2" v-permission="['fundCenter_cinema__recharge']">
                      <a-menu-item>
                        充值
                      </a-menu-item>
                    </div>
                    <div @click="onOpen(record)" v-permission="['fundCenter_cinema_open']" v-if="record.isDisabled">
                      <a-menu-item>
                        启动
                      </a-menu-item>
                    </div>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </template>
        </a-table>
      </div>
    </a-spin>
    <a-modal v-model:visible="showRecharge" title="预存金额充值" @ok="onRechargeOk" @cancel="onRechargeCancel">
      <a-spin :spinning="warnLoading">
        <a-form ref="rechargeFormRef" :model="rechargeForm" name="rechargeFormRef">
          <a-form-item label="当前余额">
            <span>{{ popupRechargeAmount }}</span>
          </a-form-item>
          <a-form-item label="充值金额" name="rechargeAmount" :rules="[{required: true, message: '必填项不允许为空'}]">
            <a-input-number v-model:value="rechargeForm.rechargeAmount" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="充值后余额">
            <span>{{ rechargeForm.rechargeAmount + popupRechargeAmount }}</span>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
    <a-modal v-model:visible="showWarning" title="项目预警值配置" @ok="onWarningOk" @cancel="onWarningCancel">
      <a-spin :spinning="warnLoading">
        <a-form ref="warningFormRef" :model="warningRef" name="warningForm">
          <a-form-item label="预警值" name="warningValue" required :rules="[{required: true, message: '必选项不允许为空'}]">
            <a-input-number :min="0" v-model:value="warningRef.warningValue" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="达到预警值时允许下单" name="isWarnPlaceOrder" required :rules="[{required: true, message: '必选项不允许为空'}]">
            <a-radio-group v-model:value="warningRef.isWarnPlaceOrder">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
    <Mode :showConfigMode="showConfigMode" @onRefreshMode="getSettingDetail" @onRefresh="onSearch" @close="onClosePage"></Mode>
  </div>
  <Edit v-if="showModal" :isEdit="isEdit" :isSee="isSee" :id="id" :fundMode="fundMode" @back="onBack"></Edit>
</template>

<script>
  import {
    Icon
  } from '@/components/icon/icon.js';
  import {
    getOrganizationList,
    getCinemaList,
  } from '@/service/modules/cinema.js';

  import {
    getFundCinemaList, getSettingDetail, setIsDisabled,
    updateCinemaDetail, getCinemaDetail, recharge
  } from '@/service/modules/preStoreCenter.js';
  import Mode from '../components/mode.vue';
  import Edit from './edit';
  export default {
    components: {
      Icon,
      Mode,
      Edit
    },
    data() {
      return {
        loading: false,
        showAll: false,
        organizationList: [],
        cinemaAllList: [],
        time: [],
        formState: {
          organizationId: 0,
          isDisabled: '',
        },
        searchData: {},
        // list: [],
        columns: [],
        pagination: {
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
          showTotal: (total) => {
            return "共 " + total + " 条";
          },
          total: 0,
          current: 1,
          pageSize: 10,
          onChange: (page) => {
            this.pagination.current = page;
            this.getFundCinemaList();
          },
          onShowSizeChange: (page, pageSize) => {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getFundCinemaList();
          }
        },
        showModal: false,
        isEdit: false,
        isSee: false,
        id: 0,
        editData: {},
        showConfigMode: false,
        cinemaList: [],
        fundMode: -1,
        showRecharge: false,
        showWarning: false,
        projectAmount: 0, // 项目余额
        rechargeForm: {
          rechargeAmount: '', // 充值
        },
        warningRef: {
          warningValue: '',
          isWarnPlaceOrder: 1
        },
        warnLoading: false,
        popupRechargeAmount: 0, // 弹窗的余额, 可能是项目的, 可能是影院的
      }
    },
    created() {
      this.getSettingDetail();
      this.getOrganizationList();
      this.onSearch();
    },
    methods: {
      onBack(isRef) {
        this.showModal = false;
        if (isRef) {
          this.getFundCinemaList();
        }
      },
      onSearch() {
        this.pagination.current = 1;
        // this.pagination.pageSize = 10;
        this.searchData = JSON.parse(JSON.stringify(this.formState));
        if (this.searchData.isDisabled === '') delete this.searchData.isDisabled;
        this.searchData.organizationId = this.searchData.organizationId ? this.searchData.organizationId : undefined;
        this.searchData.cinemaId = this.searchData.cinemaId ? this.searchData.cinemaId : undefined;
        this.getFundCinemaList();
      },
      reset() {
        this.$refs.form.resetFields();
        this.formState.organizationId = this.organizationList[0].id;
        this.onSearch();
      },
      onSubmit() {
        this.$refs.addForm.validateFields().then(async () => {
          this.loading = true;
          try {
            let postData = {
              ...this.modelRef
            }
            let ret = await updateFilmMode(postData);
            this.loading = false;
            if (ret.code === 200) {
              this.$message.success('操作成功');
              this.$refs.addForm.resetFields();
              this.showModal = false;
              this.modelRef = {};
              this.cinemaAllList();
            }
          } catch (e) {
            this.loading = false;
          }
        })
      },
      onCancel() {
        this.$refs.addForm.resetFields();
        this.modelRef = {};
        this.showModal = false;
      },
      async getOrganizationList() {
        let ret = await getOrganizationList({
          page: 1,
          pageSize: 999999
        });
        if (ret.code === 200) {
          this.organizationList = ret.data.list;
          if (this.organizationList.length) {
            this.formState.organizationId = this.organizationList[0].id;
            this.getFundCinemaList(this.formState.organizationId);
            this.getCinemaList(this.formState.organizationId);
          }
        }
      },
      async getFundCinemaList(organizationId) {
        this.cinemaAllList = [];
        this.formState.cinemaId = 0;
        let ret = await getFundCinemaList({
          page: 1,
          pageSize: this.pagination.pageSize,
          organizationId: organizationId ? organizationId : undefined,
          ...this.searchData
        })
        if (ret.code === 200) {
          this.cinemaAllList = ret.data.list;
          this.pagination.total = ret.data.totalCount;
        }
      },
      async getCinemaList(organizationId) {
        let ret = await getCinemaList({
          page: 1,
          pageSize: 999999,
          organizationId: organizationId ? organizationId : undefined,
        })
        if (ret.code === 200) {
          this.cinemaList = ret.data.list;
        }
      },
      onEdit(item) {
        this.id = item.id;
        this.isEdit = true;
        this.editData = item;
        this.showModal = true;
      },
      handleChange(info) {
        if (!info.file.status) {
          this.fileList.splice(this.fileList.length - 1, 1);
        }
        if (info.file.status === 'done') {
          this.modelRef.imgUrl = '';
          const $fileList = [...info.fileList];
          $fileList.map(file => {
            if (file.response) {
              this.modelRef.imgUrl = file.response.data.imgUrl;
              file.url = file.response.data.imgUrl;
            }
            return file;
          });
        }
      },
      onClosePage() {
        this.showConfigMode = false;
        this.$closePage(this.$router.currentRoute.value, '/index');
      },
      async getSettingDetail() {
        const ret = await getSettingDetail();
        if (ret.code == 200) {
          if (!Object.keys(ret.data).length || ret.data == 0) {
            this.showConfigMode = true;
            return
          }
          this.fundMode = ret.data;
          this.showConfigMode = false;
          if (ret.data == 1) {
            // 项目模式
            this.getProjectWarningData();
            this.columns = [
              {
                title: '所属影院',
                dataIndex: 'cinemaName'
              },{
                title: '影院编码',
                dataIndex: 'cinemaCode'
              }, {
                title: '扣款模式',
                key: 'deductionMode',
              }, {
                title: '启动状态',
                key: 'isDisabled'
              }, {
                title: '操作',
                key: 'action',
                width: 120,
                fixed: 'right'
              }
            ];
          } else if (ret.data == 2) {
            // 影院模式
            this.columns = [
              {
                title: '所属影院',
                dataIndex: 'cinemaName'
              },
              {
                title: '影院编码',
                dataIndex: 'cinemaCode'
              },
              {
                title: '扣款模式',
                key: 'deductionMode',
              },
              {
                title: '预警值',
                dataIndex: 'warningValue',
              },
              {
                title: '预存到达预警值时是否允许下单',
                key: 'isWarnPlaceOrder'
              },
              {
                title: '预存余额',
                dataIndex: 'balance'
              },
              {
                title: '启动状态',
                key: 'isDisabled'
              },
              {
                title: '操作',
                key: 'action',
                width: 120,
                fixed: 'right'
              }
            ];
          }
        }
      },
      async onOpen(record) {
        const ret = await setIsDisabled({
          id: record.id,
          isDisabled: 0
        });
        if (ret.code == 200) {
          this.onSearch();
        }
      },
      onRecharge(record) {
        if (record.id) {
          this.id = record.id;
          this.popupRechargeAmount = record.balance;
        } else {
          this.id = 0;
          this.getProjectWarningData();
        }
        this.showRecharge = true;
      },
      onWarning() {
        this.showWarning = true;
        this.getProjectWarningData();
      },
      onRechargeOk() {
        this.$refs.rechargeFormRef.validateFields().then(async () => {
          if (this.rechargeForm.rechargeAmount == 0) {
            this.$message.error('充值金额不能为0');
            return
          }
          try {
            this.warnLoading = true;
            const ret = await recharge({
              id: this.id,
              rechargeAmount: this.rechargeForm.rechargeAmount,
            });
            if (ret.code == 200) {
              this.rechargeForm.rechargeAmount = '';
              if (this.id) {
                this.getFundCinemaList();
                this.id = 0;
              } else {
                this.getProjectWarningData();
              }
              this.showRecharge = false;
            }
          } catch (e) {}
          this.warnLoading = false;
        })
      },
      onRechargeCancel() {
        this.showRecharge = false;
        this.rechargeForm.rechargeAmount = '';
        this.popupRechargeAmount = 0;
      },
      async getProjectWarningData() {
        this.warnLoading = true;
        try {
          const ret = await getCinemaDetail({
            id: 0
          });
          if (ret.code == 200) {
            this.warningRef = ret.data;
            this.projectAmount = ret.data.balance || 0;
            this.popupRechargeAmount = this.projectAmount;
          }
        } catch (e) {}
        this.warnLoading = false;
      },
      onWarningOk() {
        this.$refs.warningFormRef.validateFields().then(async () => {
          this.warnLoading = true;
          try {
            const ret = await updateCinemaDetail({
              id: 0,
              warningValue: this.warningRef.warningValue,
              isWarnPlaceOrder: this.warningRef.isWarnPlaceOrder,
            });
            if (ret.code == 200) {
              this.showWarning = false;
            }
          } catch (e) {}
          this.warnLoading = false;
        })
      },
    }
  }
</script>

<style scoped>
    .ui-form__item {
        margin-right: 30px;
    }
</style>
